/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { Col } from "../../../components/simple";

const CompanyPaymentInfo = ({ onSubmit, errors, paymentInfo, resetForm }) => {
  const { register, handleSubmit, setValue } = useForm();

  const handleFormSubmit = data => {
    onSubmit(data);
    resetForm && resetForm();
  };

  useEffect(() => {
    if (paymentInfo) {
      const {
        address_1,
        address_2,
        companyEmail,
        idNumber,
        notes
      } = paymentInfo;
      setValue("address_1", address_1);
      setValue("address_2", address_2);
      setValue("company_email", companyEmail);
      setValue("id_number", idNumber);
      setValue("notes", notes);
    }
  }, [paymentInfo]);

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="row">
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="address_1">Adress 1*</label>
        <input
          {...register("address_1", { required: true })}
          placeholder="Address 1"
          className="form-control"
        />
        {errors.address_1 && (
          <div className="text-danger">{errors.address_1.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="address_2">Adress 2</label>
        <input
          {...register("address_2")}
          placeholder="Address 2"
          className="form-control"
        />
        {errors.address_2 && (
          <div className="text-danger">{errors.address_2.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="company_email">Company Email</label>
        <input
          type="email"
          {...register("company_email", {
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            required: true
          })}
          placeholder="email"
          className="form-control"
        />
        {errors.company_email && (
          <div className="text-danger">{errors.email.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="id_number">Company ID</label>
        <input
          {...register("id_number", { required: true })}
          placeholder="Company ID"
          className="form-control"
        />
        {errors.id_number && (
          <div className="text-danger">{errors.id_number.message}</div>
        )}
      </Col>
      <Col sm={6} className="d-flex flex-column mb-3">
        <label htmlFor="notes">Notes</label>
        <textarea
          {...register("notes")}
          placeholder="Notes"
          className="form-control"
        />
        {errors.notes && (
          <div className="text-danger">{errors.notes.message}</div>
        )}
      </Col>
      <Col sm={12}>
        <input type="submit" className="btn btn-success" />
      </Col>
    </form>
  );
};

CompanyPaymentInfo.propTypes = {
  paymentInfo: PropTypes.shape({
    address_1: PropTypes.string,
    address_2: PropTypes.string,
    companyEmail: PropTypes.string,
    idNumber: PropTypes.string,
    notes: PropTypes.string
  }),
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    address_1: PropTypes.shape({
      message: PropTypes.string
    }),
    address_2: PropTypes.shape({
      message: PropTypes.string
    }),
    email: PropTypes.shape({
      message: PropTypes.string
    }),
    id_number: PropTypes.shape({
      message: PropTypes.string
    }),
    company_email: PropTypes.shape({
      message: PropTypes.string
    }),
    notes: PropTypes.shape({
      message: PropTypes.shape({
        message: PropTypes.string
      })
    })
  }).isRequired,
  resetForm: PropTypes.func
};

CompanyPaymentInfo.defaultProps = {
  paymentInfo: null,
  resetForm: undefined
};

export default CompanyPaymentInfo;
